import Vue from 'vue';
import Attachment from '@/classes/attachment';
import Fetcher from '@/classes/fetcher';

const defaultState = {
  attachments: {},
  fetcher: new Fetcher(),
  searchData: {},
};


const defaultGetters = {
  all: state => Object.keys(state.attachments).map(id => state.attachments[id]),
  attachments: state => Object.keys(state.attachments).map(id => state.attachments[id]),
  fetcher: state => state.fetcher,
  get: state => state.attachments,
  searchData: state => state.searchData,
};

const mutations = {
  setAttachments(state, attachments = []) {
    attachments.forEach(attachment => {
      const a = new Attachment(attachment);
      Vue.set(state.attachments, a.id, a);
    });
  },
  setSearchData(state, searchData) {
    state.searchData = searchData;
  },
};

const actions = {
  fetch({ dispatch, commit, getters, rootGetters }, params) {
    const fetcher = getters.fetcher;
    const cleanParams = fetcher.cleanParams(params, getters);
    const hasValidParams = fetcher.validateParams(cleanParams);
    if (hasValidParams) {
      return rootGetters['session/ajax'].get('/attachments', { params }).then(response => {
        if (response.data?.attachments) {
          commit('setAttachments', response.data?.attachments);
        }
        return response;
      });
    }
  },
};


export default {
  namespaced: true,
  state: defaultState,
  getters: defaultGetters,
  mutations,
  actions,
};
